import { Column, Container, Row } from "../../components";
import { UiTemplateGalleryModel, TrelloTemplateModel } from "../../models";

import { FullWidthCarousel, TrelloTemplate } from "./components";
import { Section } from "./UiTemplateGallery.styles";

type UiTemplateGalleryProps = {
    readonly model: UiTemplateGalleryModel;
};

const UiTemplateGalleryProps = ({ model }: UiTemplateGalleryProps) => {
    const {
        templates,
        carousel,
        reduced,
        horizontalAlignment = "center"
    } = model.content;

    return (
        <Section data-testid="template-gallery">
            {carousel ? (
                <FullWidthCarousel
                    arrows={true}
                    templates={templates as TrelloTemplateModel[]}
                    transitionTimeInSeconds={0.6}
                    reduced={reduced}
                />
            ) : (
                <Container>
                    <Row align={horizontalAlignment}>
                        {templates
                            .filter(({ type }) => type === "trelloTemplate")
                            .map((template, index) => (
                                <Column
                                    md={{ span: "6" }}
                                    lg={{ span: "4" }}
                                    key={index}
                                >
                                    <TrelloTemplate
                                        model={template}
                                        reduced={reduced}
                                    />
                                </Column>
                            ))}
                    </Row>
                </Container>
            )}
        </Section>
    );
};

export default UiTemplateGalleryProps;
